var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
        "content-class": "configuration-dialog",
        persistent: "",
        "max-width": "600px",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "register-ingestion-btn",
                    attrs: { color: "success" },
                  },
                  on
                ),
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
                  _vm._v(
                    _vm._s(_vm.$t("Button.CreateConfiguration")) + "\n    "
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            { attrs: { flat: "", dark: "" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Create Configuration")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticStyle: { overflow: "auto" } },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c(_vm.formComponent, {
                    ref: "configurationComponent",
                    tag: "component",
                    on: {
                      validate: _vm.onValidate,
                      setValidated: _vm.setValidated,
                      submit: _vm.onSubmit,
                      block: _vm.onBlock,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            { staticStyle: { "border-top": "1px solid #dddddd" } },
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        disabled: !_vm.isValidated || _vm.isBlocked,
                        loading: _vm.isSaving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("done")]),
                      _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }